import { ActivityEventProcessType } from '@warebee/shared/import-converter';

export const complianceKpis /*: WarehouseKPI[] */ = [
  // Safety Incident Rate
  {
    id: 'safety_incident_rate',
    processType: ActivityEventProcessType.HANDLING_HAZMAT,
    category: 'compliance',
    title: 'Safety Incident Rate',
    description: 'Number of safety incidents per 200,000 labor hours',
    unit: 'incidents',
    formula: '(COUNT(safety_incidents) / SUM(labor_hours)) * 200000',
    tags: ['safety', 'compliance'],
    benchmark: {
      standards: {
        site: {
          target: 3,
          warning: { upper: 5 },
          critical: { upper: 7 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P365D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 7 },
            { label: 'Warning', min: 7.01, max: 5 },
            { label: 'Target', min: 5.01, max: 3 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P365D',
    drillDimensions: ['incident_type', 'location', 'shift'],
    alertTopic: 'warehouse.alerts.compliance.safety',
  },
  // ... (repeat for all compliance KPIs, converting each benchmark) ...
];

export default complianceKpis;
